import './Balls.scss';

const Balls = (props) => {
  const className = `
    mdl-ball
    ${props.left ? 'mdl-ball--left' : ''}
    ${props.mobileHidden ? 'mobile-hidden' : ''}
    ${props.mobileRight ? 'mdl-ball--mobile-right' : ''}
  `;

  return (
    <div className={className}>
      <div/>
      <div/>
    </div>
  )
}

export default Balls;